import styled from 'styled-components';

export default styled.div`
	height: ${({height}) => height || '100%'};
	background: #ddd;
`;
